import {mapGetters} from "vuex";

const openCargo = {
    computed: {
        ...mapGetters('users', [
            'getMeBasic',
        ]),
        ...mapGetters('cargo', ['getCargo'])
    },
    methods: {
        openCargo(cargoId) {
            if (/(android)/i.test(navigator.userAgent)) {
                const cargo = this.getCargo(cargoId);
                this.$store.commit('setLoadingCargoId', cargoId);
                if (!cargo.opened) {
                    return this.$store.dispatch('cargo/patch', {
                        id: cargoId,
                        opened: [ {
                            ...this.getMeBasic,
                            openedAt: new Date(),
                            closedAt: null
                        } ]
                    });
                } else if (!_.find(cargo.opened, { 'userId': this.getMeBasic.userId, 'closedAt': null })) {
                    const updatedArray = cargo.opened;
                    updatedArray.push({
                        ...this.getMeBasic,
                        openedAt: new Date(),
                        closedAt: null
                    });
                    return this.$store.dispatch('cargo/patch', {
                        id: cargoId,
                        opened: updatedArray
                    });
                }
            }
        },
        getOpenUsers(cargoId) {
            const cargo = this.getCargo(cargoId);
            if (cargo.opened) {
                return _.filter(cargo.opened, { 'closedAt': null });
            } else {
                return [];
            }
        },
        getLoadedUsers(cargoId) {
            const cargo = this.getCargo(cargoId);
            if (cargo.loadedUsers) {
                return _.uniqBy(cargo.loadedUsers, 'userId');
            } else {
                return [];
            }
        }
    }
};

export {
    openCargo
};
